<template>
  <a-spin :spinning="spinning" tip="正在加载...">
    <div class="info">
      <div class="pt-6 step-form-form">
        <a-steps :current="current">
          <a-step title="填写信息" />
          <a-step title="完成" />
        </a-steps>
      </div>
      <div class="mt-6">
        <div v-show="current === 0">
          <Step1 @next="handleStepNext" :bidderInfo="bidderInfo" :reopen="reopen" />
        </div>
        <div v-show="current === 1">
          <Step2 @next="handleStepNext" />
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
  import { contract_by_uuid } from '@/api/contract';
  import Step1 from './step/step1.vue';
  import Step2 from './step/step2.vue';
  export default {
    components: {
      Step1,
      Step2,
    },
    data() {
      return {
        current: 0,
        reopen: 0,
        activated: false,
        spinning: true,
        bidderInfo: {},
      };
    },
    mounted() {
      this.getInfo();
    },
    activated() {
      this.activated = !this.activated;
      this.current = 0;
      this.reopen++;
    },
    methods: {
      async getInfo() {
        this.spinning = true;
        await this.$store.dispatch('user/loginggb', {
          id: this.$route.query.id,
          uuid: this.$route.query.uuid,
          type: 4,
          mode: 'none', //不要默认的错误提示
          ggb: 'yuhuan',
        });

        this.bidderInfo = await contract_by_uuid(this.$route.query.id, this.$route.query.uuid);
        if (this.bidderInfo.is_confirm) {
          if (this.$route.query.type == '2') {
            this.$router.push(`/admin/contract_detail/${this.bidderInfo.id}?tab=2`);
          } else if (this.$route.query.type == '4') {
            this.$router.push(`/admin/contract_detail/${this.bidderInfo.id}?tab=4`);
          } else {
            this.$router.push(`/admin/contract_detail/${this.bidderInfo.id}`);
          }
        }
        this.spinning = false;
      },
      handleStepNext() {
        this.activated = false;
        this.current++;
      },
    },
  };
</script>
<style scoped>
  .info {
    background: #ffffff;
    min-height: calc(100vh - 135px)
  }
  .step-form-form {
    width: 960px;
    margin: 0 auto 0 auto;
  }
</style>
